import * as React from 'react';
import { createPortal } from 'react-dom';

export function HeaderActions({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = React.useState(false);
  const portalRef = React.useRef<HTMLElement | null>(null);

  // `useLayoutEffect` (not `useEffect`) resolves the portal target before
  // paint, so the actions don't render one frame late.
  React.useLayoutEffect(() => {
    portalRef.current = document.getElementById('header-actions');
    if (portalRef.current) {
      setMounted(true);
    }
  }, []);

  if (!mounted || !portalRef.current) return null;

  return createPortal(
    // Fade in (matching the content-section transition) so header actions
    // like "Back to Campaigns" ease in instead of popping in suddenly when
    // a page that registers them mounts.
    <div className="flex items-center gap-2 animate-in fade-in-0 duration-300 ease-premium">
      {children}
    </div>,
    portalRef.current
  );
}
